module.exports = __webpack_public_path__ + "static/img/A40.85d99260.jpg";